// extracted by mini-css-extract-plugin
export default {"headerDropdown":"headerDropdown_headerDropdown__hm-pR","headerDropdown__dropdownWrapper":"headerDropdown_headerDropdown__dropdownWrapper__qWeDS"};